const applyInheritance = sizes => {
  let prevSize;
  return sizes.map((size, index) => {
    if (size !== undefined) {
      prevSize = size;
      return size;
    }
    if (index) {
      const value = prevSize;
      return value;
    }
    return undefined;
  });
};
export default applyInheritance;